import settingService from "../services/settingsService";
import Navigable, { NavigatorMove } from "./navigable";
import Navigator from "./navigator";
import NavigatorPosition from "./navigatorPosition";
import ProjectInfo from "./projectInfo";
import User from "./user";

export default class LocationManager {
  private navigator: Navigator;
  private project: ProjectInfo;
  private user: User | undefined;

  private navigable: Navigable | null = null;

  constructor(
    navigator: Navigator,
    project: ProjectInfo,
    user: User | undefined,
  ) {
    // console.log("locationManager.construct()");

    this.navigator = navigator;
    this.project = project;
    this.user = user;

    if (this.navigator && this.project) {
      this.navigable = new Navigable();
      this.navigable.id = `locationManager`;

      const navigatorMove: NavigatorMove = async (
        navigatorPosition: NavigatorPosition,
      ) => {
        // console.log("locationManager.navigatorMove", navigatorPosition);

        if (!navigator.isPlaying) {
          // console.log("locationManager.navigatorMove.saveLocation");

          if (!this.user?.isDemoUser) {
            settingService.saveLocation(
              this.project.idProject,
              navigatorPosition,
            );
          }
        }
      };
      this.navigable.navigatorMove = navigatorMove;

      const playbackIsPlayingChanged = (isPlaying: boolean) => {
        const isPlaybackStop = !isPlaying;

        if (isPlaybackStop) {
          // console.log("locationManager.isPlaybackStop.saveLocation");

          if (this.navigator.navigatorPosition) {
            if (!this.user?.isDemoUser) {
              settingService.saveLocation(
                this.project.idProject,
                this.navigator.navigatorPosition,
              );
            }
          }
        }
      };
      this.navigable.playbackIsPlayingChanged = playbackIsPlayingChanged;

      this.navigator.attach(this.navigable);
    }
  }

  public detach = () => {
    // console.log("locationManager.detach()");

    if (this.navigable) {
      this.navigator.detach(this.navigable);
      this.navigable = null;
    }
  };
}
